import { styled } from '@mui/material/styles';
import { Box, useMediaQuery, Grid } from '@mui/material';
import Page from '../components/Page';
import { SideBarMapLive } from '../components/liveMap';
import Scrollbar from '../components/Scrollbar';
import Map from '../map/Map';
import GeofenceMap from '../map/GeofenceMap';
import AccuracyMap from '../map/AccuracyMap';
import CurrentPositionsMap from '../map/CurrentPositionsMap';
import SelectedDeviceMap from '../map/SelectedDeviceMap';
import Add3DElement from '../map/Add3DElement';
import { useTranslation } from '../common/LocalizationProvider';

const RootStyle = styled('div')(() => ({
  flexGrow: 1
}));

const MapStyle = styled(Box)(({ theme }) => ({
  height: `calc(${window.innerHeight}px - ${95}px)`,
  width: '100%',
  position: 'relative',
  [theme.breakpoints.between('xs', 'lg')]: {
    height: window.innerHeight / 2.103
  }
}));
const ContaintStyle = styled(Box)(({ theme }) => ({
  height: `calc(${window.innerHeight}px - ${95}px)`,
  overflowY: 'auto',
  overflow: 'auto',
  backgroundColor: 'rgba(255, 255, 255, 0.4)',
  backdropFilter: `blur(10px)`,
  boxShadow: 'none',
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.between('xs', 'lg')]: {
    height: window.innerHeight / 2.103,
    width: window.innerWidth
  }
}));

export default function LiveMap() {
  const t = useTranslation();
  const Up = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  return (
    <Page title={t('LM_Title')}>
      <RootStyle sx={Up ? { mt: -3, mb: -10, mr: 0, ml: -2 } : { mt: -3, mb: -10 }}>
        <Scrollbar
          sx={{
            height: '100%'
          }}
        >
          <Grid container spacing={0}>
            <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
              <MapStyle>
                <Map>
                  <Add3DElement />
                  <GeofenceMap />
                  <AccuracyMap />
                  <CurrentPositionsMap />
                  <SelectedDeviceMap />
                </Map>
              </MapStyle>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
              <ContaintStyle>
                <SideBarMapLive />
              </ContaintStyle>
            </Grid>
          </Grid>
        </Scrollbar>
      </RootStyle>
    </Page>
  );
}
